export const validateObject = ({ value, requiredKeys, component }) => {
  const missingProperties = requiredKeys.filter(
    key => !Object.prototype.hasOwnProperty.call(value, key)
  )

  if (missingProperties.length > 0) {
    /* eslint-disable no-console */
    console.error(
      `missing properties ${missingProperties.join(', ')} on ${component}`
    )
  }

  return missingProperties.length === 0
}
